
    import './styles.scoped.css';
    export default {
  "badge": "awsui_badge_1yjyg_1bob2_10",
  "badge-color-grey": "awsui_badge-color-grey_1yjyg_1bob2_56",
  "badge-color-green": "awsui_badge-color-green_1yjyg_1bob2_61",
  "badge-color-blue": "awsui_badge-color-blue_1yjyg_1bob2_66",
  "badge-color-red": "awsui_badge-color-red_1yjyg_1bob2_71",
  "badge-color-severity-critical": "awsui_badge-color-severity-critical_1yjyg_1bob2_76",
  "badge-color-severity-high": "awsui_badge-color-severity-high_1yjyg_1bob2_81",
  "badge-color-severity-medium": "awsui_badge-color-severity-medium_1yjyg_1bob2_86",
  "badge-color-severity-low": "awsui_badge-color-severity-low_1yjyg_1bob2_91",
  "badge-color-severity-neutral": "awsui_badge-color-severity-neutral_1yjyg_1bob2_96"
};
  